import { render, staticRenderFns } from "./assetdepr_bycateg.vue?vue&type=template&id=627191c8"
import script from "./assetdepr_bycateg.vue?vue&type=script&lang=js"
export * from "./assetdepr_bycateg.vue?vue&type=script&lang=js"
import style0 from "./assetdepr_bycateg.vue?vue&type=style&index=0&id=627191c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports